import moment from 'moment';
import PropTypes from 'prop-types';
import './AnnuityPaymentReport.css';
import {connect} from 'react-redux';
import React, {useEffect, useState} from 'react';

const yearOptions = (() => {
    const currentYear = moment().year();
    let startYear = 2018;
    let years = [startYear];

    while(startYear < currentYear){
        const year = startYear + 2;
        years.push(year)
        startYear++;
    };
    return years;
})();

const AnnuityPaymentReport = ({ihsAnnuityPaymentsMeta, membershipAnnuityPaymentsMeta, type, title}, context) => {
    //Initializers
    const api = context.api;

    //State
    const [annuityPaymentYear, setAnnuityPaymentYear] = useState(moment().year());

    useEffect(() => {
        api.annuityPayments.get(0,0,'', {year: annuityPaymentYear, type:type}, type+'AnnuityPayments');
    },[annuityPaymentYear]);

    //Handlers
    const handleYearChange = ({target: {value}}) => setAnnuityPaymentYear(value);

    return (
        <div className="AnnuityPaymentReport">
            <div className='reportCard'>
                <h4>{title}</h4>
                <p className='stat-number'>{type==="ihs"?ihsAnnuityPaymentsMeta.totalItems:membershipAnnuityPaymentsMeta.totalItems}</p>
                <select
                    name="annuityPaymentYear"
                    onChange={handleYearChange}
                    value={annuityPaymentYear}
                >
                    {
                        yearOptions.map( (y, index) =><option key={index} value={y}>{y}</option>)
                    }
                </select>
                <br/>
                <p className='downloadLink'><a href={api.annuityPayments.exportUrl({year:annuityPaymentYear, type: 'ihs'}, 'xlsx',`Anulaidades ${type.toUpperCase()} ${annuityPaymentYear}`)}>Descargar excel</a></p>
                <p className='downloadLink'><a href={api.annuityPayments.exportUrl({year:annuityPaymentYear, type: 'ihs'}, 'pdf',  `Anualidades ${type.toUpperCase()} ${annuityPaymentYear}`)}>Descargar PDF</a></p>
            </div>
        </div>
    );
};

AnnuityPaymentReport.contextTypes = {
    api: PropTypes.object,
    notifier: PropTypes.object
};
const mapStateToProps = ({ api: { ihsAnnuityPaymentsMeta = [], membershipAnnuityPaymentsMeta = []} }) => {
    return {ihsAnnuityPaymentsMeta, membershipAnnuityPaymentsMeta};
};
export default connect(mapStateToProps)(AnnuityPaymentReport);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/Reports/MembersReports/components/AnnuityPaymentReport/AnnuityPaymentReport.jsx